var collapsible_list_pair_default = {
  "container": "DtQeh",
  "title": "oQRRR",
  "viewerContainer": "_1fgeR",
  "titleContainer": "fU7d2",
  "expandIcon": "vdDcN",
  "dndIcon": "FpVtY",
  "RTL": "_943Du",
  "LTR": "TFMN5",
  "itemContainer": "VLqKx",
  "itemContainerViewer": "glvzW",
  "mouseDown": "MDqxN",
  "innerEditor": "_0paCV",
  "item": "EQQIB",
  "floatingAddPluginMenuWrapper": "ZeTHK",
  "childrenHidden": "G-RnO"
};
export {
  collapsible_list_pair_default as default
};
//# sourceMappingURL=collapsible-list-pair-scss.js.map
